<template>
  <div class="fixed inset-0 flex items-center justify-center bg-gray-500" @click="closeModal">
    <AppSidebar />
    <div 
      class="p-6 rounded-lg shadow-lg bg-white dark:bg-dark-bg w-11/12 md:w-2/3 lg:w-1/3 max-h-[80vh] flex flex-col mx-2"
      @click.stop
    >
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-xl font-bold dark:text-dark-text">Wiadomości do Dyspozytorów</h2>
        <!-- <button @click="closeModal" class="text-gray-500 hover:text-gray-700 dark:text-dark-text">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button> -->
      </div>

      <div class="flex-grow overflow-y-auto p-2 bg-gray-100 rounded-md dark:bg-gray-800 mb-4" ref="messageHistory">
        <div v-if="messages.length === 0" class="text-gray-500 text-center mt-24">Brak wiadomości.</div>
        <div v-for="message in messages" :key="message.id" class="mb-2">
          <div :class="{'text-right': isMyMessage(message)}">
            <div 
              class="inline-block p-2 rounded-lg"
              :class="isMyMessage(message) ? 'bg-teal-600 text-white' : 'bg-gray-400 text-white'"
            >
              <div class="text-xs text-gray-200" v-if="!isMyMessage(message)">Dyspozytor</div>
              <div class="text-xs text-gray-200" v-else>Ja</div>
              <div>{{ message.content }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="mt-4 flex flex-col space-y-4 flex-shrink-0">
        <textarea
          v-model="newMessage"
          rows="4"
          :class="{
            'border-red-500': isInputInvalid,
            'dark:border-red-500': isInputInvalid
          }"
          class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
          placeholder="Wprowadź swoją wiadomość..."
          @input="isInputInvalid = false"
        ></textarea>
        
        <button
          @click="sendMessage"
          class="bg-teal-600 hover:bg-teal-700 text-white px-4 py-3 rounded-lg font-semibold"
        >
          Wyślij wiadomość
        </button>
        
        <div v-if="isInputInvalid" class="text-red-500 text-sm mt-2">
          Wiadomość nie może być pusta.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore';
import messagesService from '@/services/messagesService';
import AppSidebar from '../AppSidebar.vue';
import { useSessionStore } from '@/stores/useSessionStore';

export default {
  name: "MessageForm",
  components: {
    AppSidebar,
  },
  props: {
    // Możesz przekazać ID dyspozytora z komponentu nadrzędnego
    dispatcherId: Number 
  },
  data() {
    return {
      newMessage: "",
      isInputInvalid: false,
      messages: [], // Nowe pole na historię wiadomości
    };
  },
  setup() {
    const authStore = useAuthStore();
    const sessionStore = useSessionStore();
    if (authStore.isAuthenticated) {
        authStore.checkExpiration();
    }
    return { user: authStore.user, sessionStore };
  },
  mounted() {
    // Załaduj historię wiadomości po zamontowaniu komponentu
    this.refreshMessages();
  },
  beforeUnmount() {
    if (this.sessionStore.intervalId) {
      clearInterval(this.sessionStore.intervalId)
      this.sessionStore.intervalId = null;
    }
  },
  methods: {
    refreshMessages() {
      this.sessionStore.startInterval(() => {
        this.loadMessages();
      }, 10000);
    },
    closeModal() {
      this.$emit("close");
    },
    sendMessage() {
      if (this.newMessage.trim() === "") {
        this.isInputInvalid = true;
        return;
      }
      
      messagesService.sendMessageFromDriver(this.user.uid, this.newMessage)
        .then(() => {
          this.newMessage = "";
          this.isInputInvalid = false;
          // Odśwież historię po wysłaniu wiadomości
          this.loadMessages(); 
        })
        .catch(error => {
          console.error("Error sending message:", error);
          this.isInputInvalid = true;
        });
    },
    async loadMessages() {
      try {
        const history = await messagesService.getChatByReceiver(this.user.uid);
        this.messages = history;
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (error) {
        console.error("Błąd podczas ładowania historii wiadomości:", error);
      }
    },
    isMyMessage(message) {
      return message.sender?.id === this.user.uid;
    },
    scrollToBottom() {
      const historyBox = this.$refs.messageHistory;
      if (historyBox) {
        historyBox.scrollTop = historyBox.scrollHeight;
      }
    }
  },
};
</script>